import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { getOperatorSupplier } from '../api/operator'
import type { OrganizationDto } from '../api/types'
import { SupplierCatalogPage } from '../components/SupplierCatalogPage'
import {
  operatorSupplierCatalogImportPath,
  operatorSupplierPath,
  operatorSuppliersPath,
} from '../operator/paths'

const supplierLabel = (supplier: OrganizationDto): string =>
  supplier.trade_name?.trim() || supplier.legal_name

export const OperatorCatalogReviewScreen = () => {
  const { organizationId: organizationIdParam } = useParams()
  const organizationId = Number(organizationIdParam)
  const [supplier, setSupplier] = useState<OrganizationDto | null>(null)

  useEffect(() => {
    if (!Number.isFinite(organizationId) || organizationId <= 0) {
      return
    }
    void getOperatorSupplier(organizationId)
      .then(setSupplier)
      .catch(() => undefined)
  }, [organizationId])

  if (!Number.isFinite(organizationId) || organizationId <= 0) {
    return (
      <section className="market-page">
        <p className="echat-error">Некорректный идентификатор поставщика.</p>
        <Link to={operatorSuppliersPath}>К списку поставщиков</Link>
      </section>
    )
  }

  const label = supplier ? supplierLabel(supplier) : null

  return (
    <SupplierCatalogPage
      organizationId={organizationId}
      importPath={operatorSupplierCatalogImportPath(organizationId)}
      title="Каталог поставщика"
      description={
        label
          ? `${label} — позиции прайс-листа и сопоставление с категориями Провизиум.`
          : 'Позиции прайс-листа и сопоставление с категориями Провизиум.'
      }
      showCatalogVersions
      backLink={
        <>
          <Link to={operatorSuppliersPath}>← Поставщики</Link>
          {' · '}
          <Link to={operatorSupplierPath(organizationId)}>Карточка</Link>
        </>
      }
    />
  )
}
